import { render } from "./HomeCCTV.vue?vue&type=template&id=38c3fda4"
import script from "./HomeCCTV.vue?vue&type=script&lang=js"
export * from "./HomeCCTV.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__